import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';
import { ResidentialService } from 'src/app/questionarie-signup/questionnaire-residential/residential.service';
import { environment } from 'src/environments/environment';
import { RecommendationService } from '../recommendation/recommendation.service';
import { _ } from 'underscore';
@Component({
  selector: 'app-status-loading',
  templateUrl: './status-loading.component.html',
  styleUrls: ['./status-loading.component.css'],
})
export class StatusLoading implements OnInit {
  status: string;
  enrollNotifyObj: any;
  url = environment.api_url;
  providerContact: any;
  hgAccountID: string;
  queryObj = {
    _id: '',
    esiid: '',
    hg_orders_id: '',
    hg_accountId: '',
  };
  updateObj = {
    processCompleted: '',
    showNotification: '',
    type: '',
  };
  notifyMessages = {
    Complete:
      'CONGRATULATIONS! You have successfully enrolled for a new energy plan. We greatly appreciate your business!',
    Failed: '',
  };
  confirmationNumber: any;
  loadNavigationLinksForEnergyProviders = {
    OtherProviders: this.redirectUrlForOtherEnergyProviders.bind(this),
    Bulb: this.redirectUrlForBulbProvider.bind(this),
    ProntoPower: this.redirectUrlForProntoProvider.bind(this),
  };

  constructor(
    private http: HttpClient,
    private router: Router,
    private residentialService: ResidentialService,
    private recommendationService: RecommendationService
  ) {}

  ngOnInit() {
    this.hgAccountID = window.location.href.split('/').pop();
    // this.validateProviderName();
    // const energyProviderName = this.validateProviderName();
    // energyProviderName === undefined
    //   ? this.router.navigate(['user-settings', this.hgAccountID])
    //   : energyProviderName === 'Bulb' || energyProviderName === 'Pronto Power'
    //   ? this.saveEnrollmentOrderDetails(energyProviderName)
    //   : this.router.navigate(['signuporder', this.hgAccountID]);
    this.getSelectedProductDetailForSafari();
  }

  validateProviderName() {
    if (JSON.parse(sessionStorage.getItem('signupProduct'))) {
      return JSON.parse(sessionStorage.getItem('signupProduct'))
        .energy_provider;
    }
  }

  saveEnrollmentOrderDetails(energyProviderName) {
    const orderDetails: any = JSON.parse(
      sessionStorage.getItem('orderDetails')
    );
    orderDetails.hg_accountId = this.hgAccountID;
    const body = new HttpParams();
    body.append('orderDetails', JSON.stringify(orderDetails));
    this.http.post(this.url + '/saveorders', body).subscribe((res: any) => {
      const result = res;
      this.loadNavigationLinksForEnergyProviders[
        this.renameEnergyProviderName(energyProviderName)
      ]();
    });
    sessionStorage.removeItem('orderDetails');
  }

  renameEnergyProviderName(itemName: string) {
    return itemName === 'Bulb' || itemName === 'Pronto Power'
      ? itemName.replace(/\s/g, '')
      : 'OtherProviders';
  }

  redirectUrlForBulbProvider() {
    this.residentialService.zipCode = sessionStorage.getItem('zipCode');
    sessionStorage.removeItem('zipCode');
    window.location.href = `https://join.bulb.com/?utm_source=HonestGorilla&utm_medium=pcw&utm_campaign=HonestGorilla`;
  }

  redirectUrlForProntoProvider() {
    this.router.navigate(['prepaidoption', this.hgAccountID]);
  }

  redirectUrlForOtherEnergyProviders() {
    this.router.navigate(['signuporder', this.hgAccountID]);
  }

  getSelectedProductDetailForSafari() {
    const body = new HttpParams();
    let energyProviderName;
    this.residentialService
      .getSelectedProductDetailForSafari()
      .subscribe((res: any) => {
        if (!_.isEmpty(sessionStorage.getItem('userResponse')) && sessionStorage.getItem('userResponse') != null) {
        
        sessionStorage.setItem(
          'userResponse',
          JSON.stringify(res[0].userResponses)
        );
        }
        this.recommendationService.signupProduct = res[0];
        energyProviderName =
          this.recommendationService.signupProduct.energy_provider;
        energyProviderName === undefined
          ? this.router.navigate(['user-settings', this.hgAccountID])
          : energyProviderName === 'Bulb' ||
            energyProviderName === 'Pronto Power'
          ? this.saveEnrollmentOrderDetails(energyProviderName)
          : this.router.navigate(['signuporder', this.hgAccountID]);
      });
  }
}
